import React from 'react';
import { useTranslation } from 'react-i18next';
import { brands } from '../homeData';
import styles from './Brands.module.css';

const Brands = () => {
  const { t } = useTranslation();

  const getBrandFeatures = (brandId) => {
    const brandMap = {
      1: 'equinox',
      2: 'endaxi',
      3: 'lora',
      4: 'chemiccount'
    };
    return t(`home.brands.${brandMap[brandId]}.features`, { returnObjects: true });
  };

  return (
    <section className={styles.brandsInfoContainer}>
      {brands.map((brand) => (
        <div key={brand.id} className={styles.brandsCard}>
          <div className={styles.brandsImageContainer}>
            <img
              src={brand.image}
              alt={`Brand ${brand.id}`}
              className={styles.brandsImage}
            />
          </div>
          <div className={styles.brandsContent}>
            <ul>
              {getBrandFeatures(brand.id).map((feat, i) => (
                <li key={i}>{feat}</li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </section>
  );
};

export default React.memo(Brands);
